import type { ReactElement } from 'react'

import { useTranslate } from '@orus.eu/pharaoh'
import { LoadingRegion } from '@orus.eu/pharaoh-next/components/ui/loading-region'
import { Section } from '@orus.eu/pharaoh-next/components/ui/section'
import { Skeleton } from '@orus.eu/pharaoh-next/components/ui/skeleton'
import { View } from '@orus.eu/pharaoh-next/components/ui/view'

export function SearchDocumentationPageSkeleton(): ReactElement {
  const translate = useTranslate()

  // Match the loaded view's stacking context so the legacy BO menu stays above the pending header.
  return (
    <LoadingRegion label={translate('loading')}>
      <View.Root
        className="
          max-w-[1200px]
          max-lg:isolate
          lg:max-w-[1200px]
        "
      >
        <View.Header>
          <Skeleton variant="text" width={200} height={32} />
        </View.Header>
        <View.Body>
          <Skeleton variant="text" width="100%" />
          <Skeleton variant="block" height={240} />
          {[0, 1, 2].map((section) => (
            <Section.Root key={section}>
              <Section.Header>
                <Skeleton variant="text" width={220} height={24} />
              </Section.Header>
              <Section.Body>
                <Skeleton variant="block" height={240} />
              </Section.Body>
            </Section.Root>
          ))}
        </View.Body>
      </View.Root>
    </LoadingRegion>
  )
}
